window.addEventListener('unhandledrejection', event => {
  event.preventDefault();
  console.warn(event.reason);
});

const req = require.context(
  './', // context folder
  true, // include subdirectories
  /\.js$/ // RegExp
);

const features = req.keys().map(key => {
  let info = /\.\/(.+)\/index\.js$/.exec(key);
  if (!info) return;
  let item = req(key);
  item.weight = item.weight || 0;
  return item;
});

checkApp.registerFeatures(features);//eslint-disable-line


// WEBPACK FOOTER //
// ./src/index.js